<template>
    <v-list-item
        :class="{'active': widget.active}"
        :ripple="false"
    >
        <div
            :id="gtmTrackerId"
            class="widget-item"
            @click.prevent="goToWidget(widget)"
        >
            <img
                v-if="widget.icon"
                class="rounded small-icon mx-0"
                :src="widget.icon"
            >
            <v-list-item-icon v-else>
                <v-icon :class="`icon icon-${widget.id}`"/>
            </v-list-item-icon>

            <v-list-item-title
                class="text-none"
                v-html="widget.text"
            />
        </div>

        <v-btn
            v-if="hasHotspots"
            icon
            :ripple="false"
            @click.prevent="toggleHotspots"
        >
            <v-icon
                class="mdi"
                :class="{ 'rotate-icon': !hotspotsHidden }"
            >
                mdi-chevron-down
            </v-icon>
        </v-btn>
    </v-list-item>
</template>

<script>
    export default {
        name: 'Widget',
        props: {
            widget: {
                type: Object,
                required: true
            },
            hasHotspots: {
                type: Boolean,
                required: false
            },
            hotspotsHidden: {
                type: Boolean,
                required: false
            }
        },
        computed: {
            gtmTrackerId() {
                return `gtm-sidebar-cta-${this.$props.widget.id}`;
            }
        },
        data: () => ({
            hotspotImg: require('@/assets/images/sidebar-color-pin.png')
        }),
        methods: {
            goToWidget(widget) {
                this.$emit('go-to-widget', widget);
            },
            goToHotspot(hotspot) {
                this.$emit('go-to-hotspot', hotspot);
            },
            toggleHotspots() {
                this.$emit('toggle-hotspots');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .rotate-icon {
        transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
    }
</style>


// WEBPACK FOOTER //
// src/layout/sidebar/components/Widget.vue